// ייבוא של מודול ה-API החדש לתמחור
import { pricingApi } from '../services/api';

// ייבוא של כל הטיפוסים הדרושים לצורך ניהול תמחורים
import {
  UpdateLoungePricingRequest,
  LoungePricing,
  PricingTier,
  PricingTierCreateRequest,
  MeetingRoomPricing,
  UpdateMeetingRoomPricingRequest,
  UpdatePricingTierRequest,
} from 'shared-types';

// פונקציית עזר לשליפת הודעת שגיאה מתוך אובייקט שגיאה
function extractErrorMessage(error: any): string {
  console.log('Error Object:', error); // דיבאג
  return error.message || 'שגיאה בלתי צפויה.';
}

// ==========================
// =        Lounge         =
// ==========================

// שליפת תמחור נוכחי ללאונג'
export async function getCurrentLoungePricing(): Promise<LoungePricing | null> {
  try {
    return await pricingApi.lounge.getCurrent();
  } catch (error: any) {
    throw new Error(extractErrorMessage(error));
  }
}

// יצירת תמחור חדש ללאונג' עם שמירת היסטוריה
export async function createLoungePricingWithHistory(
  data: UpdateLoungePricingRequest
): Promise<LoungePricing> {
  try {
    return await pricingApi.lounge.create(data);
  } catch (error: any) {
    throw new Error(extractErrorMessage(error));
  }
}

// עדכון תמחור ללאונג' לפי מזהה
export async function updateLoungePricing(id: string, data: UpdateLoungePricingRequest): Promise<LoungePricing> {
  try {
    return await pricingApi.lounge.update(id, data);
  } catch (error: any) {
    throw new Error(extractErrorMessage(error));
  }
}

// מחיקת תמחור ללאונג' לפי מזהה
export async function deleteLoungePricing(id: string): Promise<void> {
  try {
    await pricingApi.lounge.delete(id);
  } catch (error: any) {
    throw new Error(extractErrorMessage(error));
  }
}

// שליפת כל היסטוריית התמחור של הלאונג'
export async function getAllLoungePricingHistory(): Promise<LoungePricing[]> {
  try {
    return await pricingApi.lounge.getHistory();
  } catch (error: any) {
    throw new Error(extractErrorMessage(error));
  }
}

// ==============================
// =     Workspace Pricing      =
// ==============================

// שליפת שכבת תמחור נוכחית לפי סוג סביבת עבודה (כמו PRIVATE_ROOM)
export async function getCurrentPricingTier(workspaceType: string): Promise<PricingTier | null> {
  try {
    return await pricingApi.tier.getCurrent(workspaceType);
  } catch (error: any) {
    throw new Error(extractErrorMessage(error));
  }
}

// יצירת שכבת תמחור עם שמירת היסטוריה
export async function createPricingTierWithHistory(data: UpdatePricingTierRequest): Promise<PricingTier> {
  try {
    return await pricingApi.tier.create(data);
  } catch (error: any) {
    throw new Error(extractErrorMessage(error));
  }
}

// יצירת שכבת תמחור או עדכון אם קיימת
export async function createOrUpdatePricingTier(data: PricingTierCreateRequest): Promise<PricingTier> {
  try {
    return await pricingApi.tier.createOrUpdate(data);
  } catch (error: any) {
    throw new Error(extractErrorMessage(error));
  }
}

// עדכון תמחור של שכבת תמחור לפי מזהה
export async function updatePricingTierPricing(id: string, data: UpdatePricingTierRequest): Promise<PricingTier> {
  try {
    return await pricingApi.tier.update(id, data);
  } catch (error: any) {
    throw new Error(extractErrorMessage(error));
  }
}

// מחיקת תמחור workspace לפי מזהה
export async function deletePricingTier(id: string): Promise<void> {
  try {
    await pricingApi.tier.delete(id);
  } catch (error: any) {
    throw new Error(extractErrorMessage(error));
  }
}

// ==============================
// =    Meeting Room Pricing    =
// ==============================

// שליפת תמחור נוכחי לחדרי ישיבות
export async function getCurrentMeetingRoomPricing(): Promise<MeetingRoomPricing | null> {
  try {
    return await pricingApi.meetingRoom.getCurrent();
  } catch (error: any) {
    throw new Error(extractErrorMessage(error));
  }
}

// יצירת תמחור חדש לחדרי ישיבות עם שמירת היסטוריה
export async function createMeetingRoomPricingWithHistory(data: UpdateMeetingRoomPricingRequest): Promise<MeetingRoomPricing> {
  try {
    return await pricingApi.meetingRoom.create(data);
  } catch (error: any) {
    throw new Error(extractErrorMessage(error));
  }
}

// עדכון תמחור לחדרי ישיבות לפי מזהה
export async function updateMeetingRoomPricing(id: string, data: UpdateMeetingRoomPricingRequest): Promise<MeetingRoomPricing> {
  try {
    return await pricingApi.meetingRoom.update(id, data);
  } catch (error: any) {
    throw new Error(extractErrorMessage(error));
  }
}

// מחיקת תמחור לחדרי ישיבות לפי מזהה
export async function deleteMeetingRoomPricing(id: string): Promise<void> {
  try {
    await pricingApi.meetingRoom.delete(id);
  } catch (error: any) {
    throw new Error(extractErrorMessage(error));
  }
}

// שליפת כל היסטוריית התמחור לחדרי ישיבות
export async function getAllMeetingRoomPricingHistory(): Promise<MeetingRoomPricing[]> {
  try {
    return await pricingApi.meetingRoom.getHistory();
  } catch (error: any) {
    throw new Error(extractErrorMessage(error));
  }
}
